<template>
  <b-modal id="create-economic-model" centered hide-header hide-footer>
    <div id="close">
      <i class="fas fa-times" @click="close"></i>
    </div>
    <div class="text-center">
      <h2>Start Your Economic Model</h2>
      <p>Your next step to success is to create an Economic Model.</p>
      <b-button variant="danger" to="/business-planning/economic-model">Create Economic Model</b-button>
    </div>
  </b-modal>
</template>

<script>
  export default {
    computed: {
      economicModel() {
        return this.$store.getters['economicModel/economicModel'].id ? true : false;
      }
    },
    methods: {
      close() {
        this.$bvModal.hide('create-economic-model');
      },
    },
    mounted() {
      if (!this.economicModel) {
        this.$bvModal.show('create-economic-model');
      }
    }
  };
</script>
<style lang="scss">
#create-economic-model.modal-body {
  padding-top: 0px;
}
#close {
  position: absolute;
  right: 13px;
  top: 6px;
  cursor: pointer;
}
</style>